define('TescoMobile_Checkout/js/view/progress-bar-mixin',['uiComponent', 'Magento_Checkout/js/model/step-navigator'], function (Component, stepNavigator) {
  'use strict';

  var mixin = {
    defaults: {
      template: 'TescoMobile_Checkout/progress-bar'
    },
    isStepLocked: function (item) {
      if (stepNavigator.isStepLocked(item.code)) {
        return '_complete _locked';
      }
      return '_complete';
    }
  };
  return function (target) {
    return target.extend(mixin);
  };
});

